import { Action, combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';

import admin from './admin';
import entitiesReducer from './entities';
import users from './users';
import { userLoggedOut } from './users/auth';

const appReducer = combineReducers({
  users: users,
  entities: entitiesReducer,
  admin: admin
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: Action) => {
  if (action.type === userLoggedOut.type) {
    localStorage.removeItem('CurrentUser');
    storage.removeItem('persist:root');
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;